"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInputValidationState = exports.SelectInput = exports.TextInputWithValidation = exports.TextInput = exports.AnimatedInputLabel = void 0;
var preact_1 = require("preact");
var Icons_1 = require("../Common/Icons");
var TextInputValidationState;
(function (TextInputValidationState) {
    TextInputValidationState[TextInputValidationState["Info"] = 0] = "Info";
    TextInputValidationState[TextInputValidationState["Warning"] = 1] = "Warning";
    TextInputValidationState[TextInputValidationState["Success"] = 2] = "Success";
})(TextInputValidationState || (TextInputValidationState = {}));
exports.TextInputValidationState = TextInputValidationState;
var AnimatedInputLabel = function (props) {
    return ((0, preact_1.h)("div", { class: "input-group" },
        (0, preact_1.h)("label", { className: "input-label ".concat(props.isActive ? "is-active" : null), htmlFor: props.labelFor }, props.label),
        props.children));
};
exports.AnimatedInputLabel = AnimatedInputLabel;
var errorClass = 'input-validation-error-border';
var TextInput = function (props) {
    return (0, preact_1.h)("input", { id: props.elementId, name: props.elementId, type: "text", spellCheck: false, autocomplete: "off", autocorrect: "off", value: props.inputValue, maxLength: props.maxLength, onInput: function (e) { return props.handleInputChange(e.target.value); }, onBlur: function () { return props.setHasFocus(false); }, onFocus: function () { return props.setHasFocus(true); }, class: props.hasError ? errorClass : '' });
};
exports.TextInput = TextInput;
var TextInputWithValidation = function (props) {
    var getInputStateIcon = function () {
        switch (props.validationState) {
            case TextInputValidationState.Info:
                return (0, preact_1.h)(Icons_1.QuestionCircleIcon, { title: props.infoIconTitle });
            case TextInputValidationState.Warning:
                return (0, preact_1.h)(Icons_1.WarningCircleIcon, { className: "warning" });
            case TextInputValidationState.Success:
                return (0, preact_1.h)(Icons_1.CheckCircleIcon, { className: "success" });
            default:
                return null;
        }
    };
    function handleChange(value) {
        props.handleInputChange(value);
        getInputStateIcon();
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("input", { id: props.elementId, name: props.elementId, type: "text", spellCheck: false, value: props.inputValue, maxLength: props.maxLength, onInput: function (e) { return handleChange(e.target.value); }, onBlur: function () { return props.setHasFocus(false); }, onFocus: function () { return props.setHasFocus(true); }, class: props.hasError ? errorClass : '' }),
        getInputStateIcon()));
};
exports.TextInputWithValidation = TextInputWithValidation;
var SelectInput = function (props) {
    return (0, preact_1.h)("select", { id: props.elementId, name: props.elementId, value: props.inputValue, class: props.hasError ? errorClass : '', onChange: function (x) { return props.handleInputChange(x.target.value); } },
        (0, preact_1.h)("option", { hidden: true, value: "" }),
        props.selectItems.map(function (x) { return (0, preact_1.h)("option", null, x); }));
};
exports.SelectInput = SelectInput;
